import HeroImage from "./heroimage.webp";

export const Assets = {
  home: {
    hero: HeroImage,
  },
};
